<template>
  <div class="logged">
    <div class="logged-wrapper">
      <div class="img" :style="$bgd($store.state.user.gravatar)" />
      <p>您已登录</p>
      <div v-if="$store.state.isWechat" class="btn-link" @click="$emit('next')">
        <span>返回上一页</span>
      </div>
      <div v-else class="btn-link" @click="$emit('logout')">
        <i class="anyteachicon anyteach-tuichu" />
        <span>退出</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Logged",
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

.logged {
  height: 50vh;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logged-wrapper {
  padding-bottom: 100px;
  text-align: center;
  .img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin: 0 auto 5px auto;
  }
  p {
    font-size: 0.9rem;
    opacity: 0.6;
  }
}
</style>
